module.exports = __webpack_public_path__ + "img/ID-01.aa3d1662.svg";